import { arrayOf, number, shape, string } from 'prop-types';

export default shape({
    createdAt: number.isRequired,
    domain: string.isRequired,
    id: string.isRequired,
    linkIds: arrayOf(string).isRequired,
});
